import Vue from 'vue';
import VueRouter, { RawLocation, Route } from 'vue-router';
import routes from './route';
import APP_UTILITIES from '@/utilities/commonFunctions';
import APP_CONST from '@/constants/AppConst';
import applicationStore from '@/store/modules/applications/applicationStore';
import { logoutResponseObj } from '@/services/userService/users-api';
import commonEntry from '@/store/modules/commonEntry';
import cartModule from '@/store/modules/checkout/cart/module';
import { getInstance } from '@/auth';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// avoid rouiting to the same path if we are already on the same page
function isAlreadyOnRoute({
  from,
  next,
  to,
}: {
  from: Route;
  to: Route;
  next: (
    to?: false | void | RawLocation | ((vm: Vue) => any) | undefined
  ) => void;
}): void {
  if (to.path === from.path) {
    next(false);
  } else {
    next();
  }
}

router.beforeEach(async (to, from, next) => {
  const authService = getInstance();

  const name = to.name ? to.name : 'BellXcel';
  document.title = to.meta.name ? to.meta.name : name;

  const urlConst = APP_CONST.APP_ROUTES.DASHBOARD.path;
  const sitesURL = '/application/sites';
  const formsURL = '/application/forms';
  let jsonToken = !authService.loading && authService.isAuthenticated;
  if (!jsonToken) {
    jsonToken = await new Promise((resolve, reject) => {
      if (authService.loading) {
        authService.$watch('loading', (loading: boolean) => {
          if (!loading) {
            resolve(authService.isAuthenticated);
          }
        });
      } else {
        resolve(authService.isAuthenticated);
      }
    });
  }
  if (
    cartModule.applicationsComplete &&
    to.path !== APP_CONST.APP_ROUTES.CHECKOUT_SUBMIT.path
  ) {
    cartModule.RESET_APPLICATIONS_COMPLETE();
  }

  if (to.path == APP_CONST.APP_ROUTES.REGISTER.path) {
    let accountDesign: any = APP_UTILITIES.getCookie('accountDesign') || '';
    accountDesign = accountDesign && JSON.parse(accountDesign);
    const cookieSlug = '/' + accountDesign.slug + '/';
    if (accountDesign) {
      if (location.pathname == cookieSlug) {
        if (jsonToken) {
          localStorage.removeItem('all_selected_sites');
          APP_UTILITIES.removeSpecificCookie('elasticEnrollmentId');
          applicationStore.mutateSiteList([]);
        }
      } else if (jsonToken) {
        logoutResponseObj();
        APP_UTILITIES.removeCookies();
        jsonToken = '';
        window.location.replace(location.href);
      }
    }

    isAlreadyOnRoute({ from, to, next });
  }

  switch (to.path) {
    case APP_CONST.DEFAULT_ROUTE:
      isAlreadyOnRoute({ from, to, next });
      break;
    case APP_CONST.APP_ROUTES.SIGNUP.path:
    case APP_CONST.APP_ROUTES.SIGNIN.path:
      if (jsonToken) {
        if (
          authService.redirectTo ||
          (from.query.redirect && typeof from.query.redirect === 'string')
        ) {
          window.location.replace(
            `${location.origin}/${
              APP_UTILITIES.accountSlug
            }/#${authService.redirectTo || from.query.redirect}`
          );
          next(authService.redirectTo || from.query.redirect);
        } else {
          next(urlConst);
        }
      } else {
        isAlreadyOnRoute({ from, to, next });
      }
      break;
    case APP_CONST.APP_ROUTES.REGISTER.path:
      if (jsonToken) {
        next(sitesURL);
      } else {
        isAlreadyOnRoute({ from, to, next });
      }
      break;
    case APP_CONST.APP_ROUTES.RESETPASSWORD.path:
      next({ query: { redirect: to.path } });
      break;
    case urlConst:
      if (jsonToken) {
        isAlreadyOnRoute({ from, to, next });
      } else {
        next(from.path);
      }
      break;
    case formsURL:
      if (jsonToken) {
        isAlreadyOnRoute({ from, to, next });
      } else {
        next(from.path);
      }
      break;
    case urlConst:
      if (jsonToken) {
        if (authService.redirectTo) {
          window.location.replace(
            `${location.origin}/${APP_UTILITIES.accountSlug}/#${authService.redirectTo}`
          );
          next(authService.redirectTo);
          break;
        }
        isAlreadyOnRoute({ from, to, next });
      } else {
        next(from.path);
      }
      break;
    default:
      if (jsonToken) {
        isAlreadyOnRoute({ from, to, next });
      } else {
        isAlreadyOnRoute({ from, to, next });
      }
  }
});

export default router;
